import { createSelector } from 'reselect';
import type { RootState } from '@/redux/types';

export const getUserState = createSelector(
  [(state: RootState) => state.user],
  (userState) => userState
);

export const getUserId = createSelector(
  [getUserState],
  (userState) => userState.id
);

export const getUserFamily = createSelector(
  [getUserState],
  (userState) => userState.family
);

export const getUserFirstname = createSelector(
  [getUserState],
  (userState) => userState.firstname
);

export const getUserLastname = createSelector(
  [getUserState],
  (userState) => userState.lastname
);

export const getUserUsername = createSelector(
  [getUserState],
  (userState) => userState.username
);

export const getUserEmail = createSelector(
  [getUserState],
  (userState) => userState.email
);

export const getUserPoints = createSelector(
  [getUserState],
  (userState) => userState.points
);

export const getUserTooltip = createSelector(
  [getUserState],
  (userState) => userState.tooltip
);

export const getUserEntityData = createSelector(
  [getUserState],
  (userState) => userState.data
);

export const getUserUnlockedElements = createSelector(
  [getUserState],
  (userState) => userState.family?.unlockedAvatarElements
);
